import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultRangeData = {
  id: 0,
  enabled: true,
  name: '',
  tallyAlias: '',
  icon: '',
  image: '',
  description: '',
  priority: 0,
  featured: false,
  bgcolor: null
};
export const getRanges = params => request({
  url: '/ranges',
  method: 'get',
  params
});
export const getRangeById = id => request({
  url: `/ranges/${id}`,
  method: 'get'
});
export const updateRange = (id, data) => request({
  url: `/ranges/${id}`,
  method: 'patch',
  data
});
export const deleteRange = id => request({
  url: `/ranges/${id}`,
  method: 'delete'
});
export const createRange = data => request({
  url: '/ranges',
  method: 'post',
  data
});